import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import localforage, * as localForage from 'localforage';
import { Logo } from '../../models/logo.model';
import { GetLocalForageConFigService } from '../../services/getLocalForage.service';
import { OfflineService } from '../../services/offline.service';
import { UploadFileService } from '../../services/upload-file.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-printhd',
  templateUrl: './printhd.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class printhdComponent implements OnInit {
  print_preview: string;
  print_previewhtml: SafeHtml;
  public listener: () => void;
  urllogoKH: string;
  logo: Logo = new Logo();
  url: string;

  constructor(private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private offlineService: OfflineService,
    private getlocalconfig: GetLocalForageConFigService,
    private uploadFileService: UploadFileService,
    @Inject('BASE_URL') baseUrl: string,
    ) {
    this.urllogoKH = '';
    this.url = baseUrl + 'assets/images/Logo/';

  }

  async ngOnInit() {
    await localForage.getItem('_In').then((result: string) => {
      this.print_preview = '<a style="text-decoration: none; color: black"  href="print:">' + '\n';
      this.print_preview += result;
      this.print_preview += '<\a>';
      var tab = window.open('about:blank', '_blank');

      //this.getlocalconfig.getConfigLocalForage()
      //  .then(async result => {
      //    // tslint:disable-next-line:max-line-length
      //    await localForage.setItem("_In", this.inz);
      //  });
      //this.router.navigate(['/in']);
      /* window.location.href=this.url_callback+'in';*/
      tab.document.write(this.print_preview); // where 'html' is a variable containing your HTML
      tab.document.close();
     
      setTimeout(tab.close, 5000);
      //this.print_previewhtml = this.sanitizer.bypassSecurityTrustHtml(this.print_preview);
    });
    await this.uploadFileService.getFileName()
      .then((res: Logo) => {
        console.log(res);
        this.logo.lg_content = res.lg_content;
        this.logo.lg_overall = res.lg_overall;
        this.logo.lg_start = res.lg_start;
        // console.log(this.logo.lg_content);
        // console.log(this.logo.lg_overall);
        // console.log(this.logo.lg_start);
        this.offlineService.imgLoad(this.logo.lg_overall)
          .then((res: any) => {
            const imgURL = window.URL.createObjectURL(res[0]);
            this.urllogoKH = imgURL;
          });
     
        // console.log('logotopos ' + this.urllogotopos);
        // this.offlineService.findImages();
      });
  }

  inIframe() {
 
    var tab = window.open('about:blank', '_blank');

    //this.getlocalconfig.getConfigLocalForage()
    //  .then(async result => {
    //    // tslint:disable-next-line:max-line-length
    //    await localForage.setItem("_In", this.inz);
    //  });
    //this.router.navigate(['/in']);
   /* window.location.href=this.url_callback+'in';*/
    tab.document.write(this.print_preview); // where 'html' is a variable containing your HTML
    tab.document.close(); // to finish loading the page
  }

}



// WEBPACK FOOTER //
// ./src/app/components/printhd/printhd.component.ts